import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { EMPTY, Observable } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { switchMap } from 'rxjs/operators';
import { AuthenticationService } from "../services/auth.service";
import { environment } from "src/environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    
    // const token = this.token.getToken();
    // if (token != null) {
    //   // for Spring Boot back-end
    //   // authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });

    //   // for Node.js Express back-end
    //   authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, token) });
    // }

    constructor(
        private authService: AuthenticationService,
        private httpClient: HttpClient
    ){}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log("Intercepter in action");
        const apiRootRequestWithCreds = this.getClone(req);

        if (req.url.includes('assets/') || req.url.includes('app/')) {
            return next.handle(req); // Pass the request as-is
        }

        return next.handle(apiRootRequestWithCreds);
    }

    private getClone(req){

        let rootUrl:string = environment.backend;
        if (req.url.startsWith('?')) {
            rootUrl = rootUrl.replace(/\/$/, ''); //Removing last / , if there is ? in the end
        }

        return req.clone({
            url: rootUrl + req.url,
            withCredentials: true, //It has to be there in all
        });

    }
}